import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';

interface AcknowledgeDialogProps {
  open: boolean;
  onClose: () => void;
  selectedContracts: string[];
  onAcknowledge: () => void;
}

const AcknowledgeDialog: React.FC<AcknowledgeDialogProps> = ({ open, onClose, selectedContracts, onAcknowledge }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Batch Acknowledge</DialogTitle>
      <DialogContent>
        <Typography gutterBottom>
          Are you sure you want to acknowledge the following contracts?
        </Typography>
        <List dense>
          {selectedContracts.map(contract => (
            <ListItem key={contract}>{contract}</ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">Cancel</Button>
        <Button onClick={onAcknowledge} color="primary" variant="contained">Confirm</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AcknowledgeDialog; 